/**
 * Dashboard Root Component
 * Handles prerequisites loading and provides context
 */

import { CircularProgress } from '@mui/material';
import { useGetCurrencies } from 'src/use-cases/invoice/useInvoices';
import { LandingTopWidget } from '../../organisms/landing';
import { LayoutSidebar } from '../../organisms/sidebar/LayoutSidebar';
import { DashboardProvider } from './DashboardProvider';
import { DashboardPage } from './DashboardPage';

const Dashboard = () => {
  const { data: currencies, isLoading: isLoadingCurrencies } = useGetCurrencies('DASHBOARD');

  // Show layout with loading spinner inside content area while loading
  if (isLoadingCurrencies || !currencies?.data || currencies.data.length === 0) {
    return (
      <>
        <LandingTopWidget />
        <LayoutSidebar>
          <div className='flex-1 flex items-center justify-center min-h-[400px] bg-neutral-10'>
            <CircularProgress color='primary' />
          </div>
        </LayoutSidebar>
      </>
    );
  }

  const defaultCurrency = currencies.data[0];

  return (
    <DashboardProvider defaultCurrency={defaultCurrency} currencies={currencies.data}>
      <DashboardPage />
    </DashboardProvider>
  );
};

export default Dashboard;
